import {SET_WATCHLIST, SHOW_DIALOG} from "@/store/mutations.type";
import {DELETE_WATCHLIST, DOWNLOAD_WATCHLIST_SUMMARY} from "@/store/actions.type";
import {mapMutations} from "vuex";

export default {
	methods: {
		...mapMutations([SHOW_DIALOG]),
		editWatchlist(watchlist) {
			this[SHOW_DIALOG]({
				component: 'WatchlistSettings',
				title: 'button.watchlistSettings',
				persistent: true,
				watchlist: watchlist
			});
		},
		share(watchlist) {
			this.$store.commit(SET_WATCHLIST, watchlist);
			this[SHOW_DIALOG]({
				component: 'WatchlistShare',
				title: 'button.share'
			});
		},
		async deleteWatchlist(watchlist) {
			this.$q.dialog({
				title: this.$t('button.deleteWatchlist'),
				message: this.$t('confirmationText.deleteWatchlist', {watchlistName: watchlist.name}),
				cancel: true,
				persistent: true
			}).onOk(async () => {
				await this.$store.dispatch(DELETE_WATCHLIST, watchlist);

				if (this.$route.name !== 'watchlists') {
					await this.$router.push({name: 'watchlists'});
				}
			});
		},
		downloadWatchlistSummary(watchlist) {
			this.$store.dispatch(DOWNLOAD_WATCHLIST_SUMMARY, {
				watchlist: watchlist
			})
		}
	}
}